import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setSearch, getProducts } from "../../store/reducers/filterSlice";

class SearchBar extends React.Component {
  state = {
    value: "",
  };

  constructor(props) {
    super(props);
    this.state.value =
      props.request && props.request.search ? props.request.search : "";
  }

  componentDidUpdate(prevProps) {
    if (prevProps.request.search !== this.props.request.search) {
      this.setState({ value: this.props.request.search || "" });
    }
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value });
  };

  handleSearch = () => {
    this.props.setSearch(this.state.value);
    this.props.getProducts();
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleSearch();
    }
  };

  handleClear = () => {
    this.setState({ value: "" });
    this.props.setSearch("");
    this.props.getProducts();
  };

  render() {
    const { t } = this.props;

    return (
      <div className="search-bar-container" data-filter-part="search-bar">
        <div className="search-bar-input-wrapper">
          <input
            type="text"
            className="search-bar-input"
            placeholder={t("Search")}
            value={this.state.value}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
          />
          {this.state.value.length > 0 && (
            <button
              type="button"
              className="search-bar-clear"
              aria-label={t("Clear search")}
              onClick={this.handleClear}
            >
              &times;
            </button>
          )}
        </div>
        <button
          type="button"
          className="search-bar-submit button-submit"
          onClick={this.handleSearch}
        >
          {t("Search2")}
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    request: state.filter.request,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setSearch: (value) => (dispatch) => {
        dispatch(setSearch(value));
      },
      getProducts: () => (dispatch) => {
        dispatch(getProducts());
      },
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SearchBar));
